import { render } from "./SubprogramList.vue?vue&type=template&id=0be06b36&scoped=true"
import script from "./SubprogramList.vue?vue&type=script&lang=js"
export * from "./SubprogramList.vue?vue&type=script&lang=js"

import "./SubprogramList.vue?vue&type=style&index=0&id=0be06b36&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be06b36"]])

export default __exports__